/* tslint:disable */
/* eslint-disable */
/**
 * IRM.Web.Customer.API
 * 6d75acac-ec29-43a4-9fe0-2808f10c310c Development
 *
 * The version of the OpenAPI document: 2024.05.17.1151
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "../configuration";
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from "axios";
import globalAxios from "axios";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from "../common";
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
} from "../base";
// @ts-ignore
import { ApiDeliverySearchNFilterGridViewPostRequest } from "../models";
// @ts-ignore
import { ApiOrderCreateOrdersPostRequest } from "../models";
// @ts-ignore
import { ApiOrderDRAFTPatchRequest } from "../models";
// @ts-ignore
import { DocumentFilterDimensions } from "../models";
// @ts-ignore
import { FileUriODataResultCollection } from "../models";
// @ts-ignore
import { OrderModel } from "../models";
// @ts-ignore
import { OrderModelODataResultCollection } from "../models";
/**
 * OrderApi - axios parameter creator
 * @export
 */
export const OrderApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary Used to created orders and return release numbers
     * @param {ApiOrderCreateOrdersPostRequest} [apiOrderCreateOrdersPostRequest] The OrderCreateModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOrderCreateOrdersPost: async (
      apiOrderCreateOrdersPostRequest?: ApiOrderCreateOrdersPostRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Order/CreateOrders`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      localVarHeaderParameter["Content-Type"] =
        "application/json;odata.metadata=minimal;odata.streaming=true";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiOrderCreateOrdersPostRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get document by DocEntry and IsDraft
     * @param {number} docEntry
     * @param {string} dRAFT
     * @param {boolean} [isDraft]
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOrderDRAFTDocEntryGet: async (
      docEntry: number,
      dRAFT: string,
      isDraft?: boolean,
      $expand?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'docEntry' is not null or undefined
      assertParamExists("apiOrderDRAFTDocEntryGet", "docEntry", docEntry);
      // verify required parameter 'dRAFT' is not null or undefined
      assertParamExists("apiOrderDRAFTDocEntryGet", "dRAFT", dRAFT);
      const localVarPath = `/api/Order/{DRAFT}/{DocEntry}`
        .replace(`{${"DocEntry"}}`, encodeURIComponent(String(docEntry)))
        .replace(`{${"DRAFT"}}`, encodeURIComponent(String(dRAFT)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if (isDraft !== undefined) {
        localVarQueryParameter["IsDraft"] = isDraft;
      }

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Default action to acquire list of documents by IsDraft
     * @param {string} dRAFT
     * @param {boolean} [isDraft]
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOrderDRAFTGet: async (
      dRAFT: string,
      isDraft?: boolean,
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      $expand?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'dRAFT' is not null or undefined
      assertParamExists("apiOrderDRAFTGet", "dRAFT", dRAFT);
      const localVarPath = `/api/Order/{DRAFT}`.replace(
        `{${"DRAFT"}}`,
        encodeURIComponent(String(dRAFT))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if (isDraft !== undefined) {
        localVarQueryParameter["IsDraft"] = isDraft;
      }

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top;
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip;
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter;
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby;
      }

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} docEntry
     * @param {string} dRAFT
     * @param {boolean} [isDraft]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOrderDRAFTGetFormIdDocEntryGet: async (
      docEntry: number,
      dRAFT: string,
      isDraft?: boolean,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'docEntry' is not null or undefined
      assertParamExists(
        "apiOrderDRAFTGetFormIdDocEntryGet",
        "docEntry",
        docEntry
      );
      // verify required parameter 'dRAFT' is not null or undefined
      assertParamExists("apiOrderDRAFTGetFormIdDocEntryGet", "dRAFT", dRAFT);
      const localVarPath = `/api/Order/{DRAFT}/GetFormId/{DocEntry}`
        .replace(`{${"DocEntry"}}`, encodeURIComponent(String(docEntry)))
        .replace(`{${"DRAFT"}}`, encodeURIComponent(String(dRAFT)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if (isDraft !== undefined) {
        localVarQueryParameter["IsDraft"] = isDraft;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary
     * @param {string} dRAFT
     * @param {ApiOrderDRAFTPatchRequest} [apiOrderDRAFTPatchRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOrderDRAFTPatch: async (
      dRAFT: string,
      apiOrderDRAFTPatchRequest?: ApiOrderDRAFTPatchRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'dRAFT' is not null or undefined
      assertParamExists("apiOrderDRAFTPatch", "dRAFT", dRAFT);
      const localVarPath = `/api/Order/{DRAFT}`.replace(
        `{${"DRAFT"}}`,
        encodeURIComponent(String(dRAFT))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PATCH",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      localVarHeaderParameter["Content-Type"] =
        "application/json;odata.metadata=minimal;odata.streaming=true";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiOrderDRAFTPatchRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary
     * @param {string} dRAFT
     * @param {ApiOrderDRAFTPatchRequest} [apiOrderDRAFTPatchRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOrderDRAFTUpdatePost: async (
      dRAFT: string,
      apiOrderDRAFTPatchRequest?: ApiOrderDRAFTPatchRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'dRAFT' is not null or undefined
      assertParamExists("apiOrderDRAFTUpdatePost", "dRAFT", dRAFT);
      const localVarPath = `/api/Order/{DRAFT}/Update`.replace(
        `{${"DRAFT"}}`,
        encodeURIComponent(String(dRAFT))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      localVarHeaderParameter["Content-Type"] =
        "application/json;odata.metadata=minimal;odata.streaming=true";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiOrderDRAFTPatchRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get document by DocEntry and IsDraft
     * @param {number} docEntry
     * @param {boolean} [isDraft]
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOrderDocEntryGet: async (
      docEntry: number,
      isDraft?: boolean,
      $expand?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'docEntry' is not null or undefined
      assertParamExists("apiOrderDocEntryGet", "docEntry", docEntry);
      const localVarPath = `/api/Order/{DocEntry}`.replace(
        `{${"DocEntry"}}`,
        encodeURIComponent(String(docEntry))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if (isDraft !== undefined) {
        localVarQueryParameter["IsDraft"] = isDraft;
      }

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Default action to acquire list of documents by IsDraft
     * @param {boolean} [isDraft]
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOrderGet: async (
      isDraft?: boolean,
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      $expand?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Order`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if (isDraft !== undefined) {
        localVarQueryParameter["IsDraft"] = isDraft;
      }

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top;
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip;
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter;
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby;
      }

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Used to provide valid dimensions of Order GridView
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOrderGetDocumentFilterDimensionsGet: async (
      $filter?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Order/GetDocumentFilterDimensions`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} docEntry
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOrderGetFileUriListDocEntryGet: async (
      docEntry: number,
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'docEntry' is not null or undefined
      assertParamExists(
        "apiOrderGetFileUriListDocEntryGet",
        "docEntry",
        docEntry
      );
      const localVarPath = `/api/Order/GetFileUriList/{DocEntry}`.replace(
        `{${"DocEntry"}}`,
        encodeURIComponent(String(docEntry))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top;
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip;
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter;
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} docEntry
     * @param {boolean} [isDraft]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOrderGetFormIdDocEntryGet: async (
      docEntry: number,
      isDraft?: boolean,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'docEntry' is not null or undefined
      assertParamExists("apiOrderGetFormIdDocEntryGet", "docEntry", docEntry);
      const localVarPath = `/api/Order/GetFormId/{DocEntry}`.replace(
        `{${"DocEntry"}}`,
        encodeURIComponent(String(docEntry))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if (isDraft !== undefined) {
        localVarQueryParameter["IsDraft"] = isDraft;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary
     * @param {ApiOrderDRAFTPatchRequest} [apiOrderDRAFTPatchRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOrderPatch: async (
      apiOrderDRAFTPatchRequest?: ApiOrderDRAFTPatchRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Order`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PATCH",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      localVarHeaderParameter["Content-Type"] =
        "application/json;odata.metadata=minimal;odata.streaming=true";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiOrderDRAFTPatchRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [searchString]
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOrderSearchContractDetailsGet: async (
      searchString?: string,
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      $expand?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Order/SearchContractDetails`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if (searchString !== undefined) {
        localVarQueryParameter["SearchString"] = searchString;
      }

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top;
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip;
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter;
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby;
      }

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [searchString]
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOrderSearchGridViewGet: async (
      searchString?: string,
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      $expand?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Order/SearchGridView`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if (searchString !== undefined) {
        localVarQueryParameter["SearchString"] = searchString;
      }

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top;
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip;
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter;
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby;
      }

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Searches the grid view.
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {ApiDeliverySearchNFilterGridViewPostRequest} [apiDeliverySearchNFilterGridViewPostRequest] The filter and search string requirement.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOrderSearchNFilterGridViewPost: async (
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      $expand?: string,
      apiDeliverySearchNFilterGridViewPostRequest?: ApiDeliverySearchNFilterGridViewPostRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Order/SearchNFilterGridView`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top;
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip;
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter;
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby;
      }

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand;
      }

      localVarHeaderParameter["Content-Type"] =
        "application/json;odata.metadata=minimal;odata.streaming=true";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiDeliverySearchNFilterGridViewPostRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary
     * @param {ApiOrderDRAFTPatchRequest} [apiOrderDRAFTPatchRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOrderUpdatePost: async (
      apiOrderDRAFTPatchRequest?: ApiOrderDRAFTPatchRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Order/Update`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      localVarHeaderParameter["Content-Type"] =
        "application/json;odata.metadata=minimal;odata.streaming=true";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiOrderDRAFTPatchRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get document by DocEntry and IsDraft
     * @param {number} docEntry
     * @param {boolean} [isDraft]
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    docEntryGet: async (
      docEntry: number,
      isDraft?: boolean,
      $expand?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'docEntry' is not null or undefined
      assertParamExists("docEntryGet", "docEntry", docEntry);
      const localVarPath = `/api/Order({DocEntry})`.replace(
        `{${"DocEntry"}}`,
        encodeURIComponent(String(docEntry))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if (isDraft !== undefined) {
        localVarQueryParameter["IsDraft"] = isDraft;
      }

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * OrderApi - functional programming interface
 * @export
 */
export const OrderApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = OrderApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Used to created orders and return release numbers
     * @param {ApiOrderCreateOrdersPostRequest} [apiOrderCreateOrdersPostRequest] The OrderCreateModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiOrderCreateOrdersPost(
      apiOrderCreateOrdersPostRequest?: ApiOrderCreateOrdersPostRequest,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<{ [key: string]: number }>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiOrderCreateOrdersPost(
          apiOrderCreateOrdersPostRequest,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary Get document by DocEntry and IsDraft
     * @param {number} docEntry
     * @param {string} dRAFT
     * @param {boolean} [isDraft]
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiOrderDRAFTDocEntryGet(
      docEntry: number,
      dRAFT: string,
      isDraft?: boolean,
      $expand?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderModel>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiOrderDRAFTDocEntryGet(
          docEntry,
          dRAFT,
          isDraft,
          $expand,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary Default action to acquire list of documents by IsDraft
     * @param {string} dRAFT
     * @param {boolean} [isDraft]
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiOrderDRAFTGet(
      dRAFT: string,
      isDraft?: boolean,
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      $expand?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<OrderModelODataResultCollection>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiOrderDRAFTGet(
          dRAFT,
          isDraft,
          $top,
          $skip,
          $filter,
          $orderby,
          $expand,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {number} docEntry
     * @param {string} dRAFT
     * @param {boolean} [isDraft]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiOrderDRAFTGetFormIdDocEntryGet(
      docEntry: number,
      dRAFT: string,
      isDraft?: boolean,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiOrderDRAFTGetFormIdDocEntryGet(
          docEntry,
          dRAFT,
          isDraft,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary
     * @param {string} dRAFT
     * @param {ApiOrderDRAFTPatchRequest} [apiOrderDRAFTPatchRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiOrderDRAFTPatch(
      dRAFT: string,
      apiOrderDRAFTPatchRequest?: ApiOrderDRAFTPatchRequest,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderModel>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiOrderDRAFTPatch(
          dRAFT,
          apiOrderDRAFTPatchRequest,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary
     * @param {string} dRAFT
     * @param {ApiOrderDRAFTPatchRequest} [apiOrderDRAFTPatchRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiOrderDRAFTUpdatePost(
      dRAFT: string,
      apiOrderDRAFTPatchRequest?: ApiOrderDRAFTPatchRequest,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderModel>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiOrderDRAFTUpdatePost(
          dRAFT,
          apiOrderDRAFTPatchRequest,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary Get document by DocEntry and IsDraft
     * @param {number} docEntry
     * @param {boolean} [isDraft]
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiOrderDocEntryGet(
      docEntry: number,
      isDraft?: boolean,
      $expand?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderModel>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiOrderDocEntryGet(
          docEntry,
          isDraft,
          $expand,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary Default action to acquire list of documents by IsDraft
     * @param {boolean} [isDraft]
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiOrderGet(
      isDraft?: boolean,
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      $expand?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<OrderModelODataResultCollection>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiOrderGet(
        isDraft,
        $top,
        $skip,
        $filter,
        $orderby,
        $expand,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary Used to provide valid dimensions of Order GridView
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiOrderGetDocumentFilterDimensionsGet(
      $filter?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<DocumentFilterDimensions>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiOrderGetDocumentFilterDimensionsGet(
          $filter,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {number} docEntry
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiOrderGetFileUriListDocEntryGet(
      docEntry: number,
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<FileUriODataResultCollection>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiOrderGetFileUriListDocEntryGet(
          docEntry,
          $top,
          $skip,
          $filter,
          $orderby,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {number} docEntry
     * @param {boolean} [isDraft]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiOrderGetFormIdDocEntryGet(
      docEntry: number,
      isDraft?: boolean,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiOrderGetFormIdDocEntryGet(
          docEntry,
          isDraft,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary
     * @param {ApiOrderDRAFTPatchRequest} [apiOrderDRAFTPatchRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiOrderPatch(
      apiOrderDRAFTPatchRequest?: ApiOrderDRAFTPatchRequest,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderModel>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiOrderPatch(
        apiOrderDRAFTPatchRequest,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {string} [searchString]
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiOrderSearchContractDetailsGet(
      searchString?: string,
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      $expand?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<OrderModelODataResultCollection>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiOrderSearchContractDetailsGet(
          searchString,
          $top,
          $skip,
          $filter,
          $orderby,
          $expand,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {string} [searchString]
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiOrderSearchGridViewGet(
      searchString?: string,
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      $expand?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<OrderModelODataResultCollection>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiOrderSearchGridViewGet(
          searchString,
          $top,
          $skip,
          $filter,
          $orderby,
          $expand,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary Searches the grid view.
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {ApiDeliverySearchNFilterGridViewPostRequest} [apiDeliverySearchNFilterGridViewPostRequest] The filter and search string requirement.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiOrderSearchNFilterGridViewPost(
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      $expand?: string,
      apiDeliverySearchNFilterGridViewPostRequest?: ApiDeliverySearchNFilterGridViewPostRequest,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<OrderModelODataResultCollection>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiOrderSearchNFilterGridViewPost(
          $top,
          $skip,
          $filter,
          $orderby,
          $expand,
          apiDeliverySearchNFilterGridViewPostRequest,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary
     * @param {ApiOrderDRAFTPatchRequest} [apiOrderDRAFTPatchRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiOrderUpdatePost(
      apiOrderDRAFTPatchRequest?: ApiOrderDRAFTPatchRequest,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderModel>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiOrderUpdatePost(
          apiOrderDRAFTPatchRequest,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary Get document by DocEntry and IsDraft
     * @param {number} docEntry
     * @param {boolean} [isDraft]
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async docEntryGet(
      docEntry: number,
      isDraft?: boolean,
      $expand?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderModel>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.docEntryGet(
        docEntry,
        isDraft,
        $expand,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * OrderApi - factory interface
 * @export
 */
export const OrderApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = OrderApiFp(configuration);
  return {
    /**
     *
     * @summary Used to created orders and return release numbers
     * @param {OrderApiApiOrderCreateOrdersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOrderCreateOrdersPost(
      requestParameters: OrderApiApiOrderCreateOrdersPostRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<{ [key: string]: number }> {
      return localVarFp
        .apiOrderCreateOrdersPost(
          requestParameters.apiOrderCreateOrdersPostRequest,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get document by DocEntry and IsDraft
     * @param {OrderApiApiOrderDRAFTDocEntryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOrderDRAFTDocEntryGet(
      requestParameters: OrderApiApiOrderDRAFTDocEntryGetRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<OrderModel> {
      return localVarFp
        .apiOrderDRAFTDocEntryGet(
          requestParameters.docEntry,
          requestParameters.dRAFT,
          requestParameters.isDraft,
          requestParameters.$expand,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Default action to acquire list of documents by IsDraft
     * @param {OrderApiApiOrderDRAFTGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOrderDRAFTGet(
      requestParameters: OrderApiApiOrderDRAFTGetRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<OrderModelODataResultCollection> {
      return localVarFp
        .apiOrderDRAFTGet(
          requestParameters.dRAFT,
          requestParameters.isDraft,
          requestParameters.$top,
          requestParameters.$skip,
          requestParameters.$filter,
          requestParameters.$orderby,
          requestParameters.$expand,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {OrderApiApiOrderDRAFTGetFormIdDocEntryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOrderDRAFTGetFormIdDocEntryGet(
      requestParameters: OrderApiApiOrderDRAFTGetFormIdDocEntryGetRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<number> {
      return localVarFp
        .apiOrderDRAFTGetFormIdDocEntryGet(
          requestParameters.docEntry,
          requestParameters.dRAFT,
          requestParameters.isDraft,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary
     * @param {OrderApiApiOrderDRAFTPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOrderDRAFTPatch(
      requestParameters: OrderApiApiOrderDRAFTPatchRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<OrderModel> {
      return localVarFp
        .apiOrderDRAFTPatch(
          requestParameters.dRAFT,
          requestParameters.apiOrderDRAFTPatchRequest,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary
     * @param {OrderApiApiOrderDRAFTUpdatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOrderDRAFTUpdatePost(
      requestParameters: OrderApiApiOrderDRAFTUpdatePostRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<OrderModel> {
      return localVarFp
        .apiOrderDRAFTUpdatePost(
          requestParameters.dRAFT,
          requestParameters.apiOrderDRAFTPatchRequest,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get document by DocEntry and IsDraft
     * @param {OrderApiApiOrderDocEntryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOrderDocEntryGet(
      requestParameters: OrderApiApiOrderDocEntryGetRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<OrderModel> {
      return localVarFp
        .apiOrderDocEntryGet(
          requestParameters.docEntry,
          requestParameters.isDraft,
          requestParameters.$expand,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Default action to acquire list of documents by IsDraft
     * @param {OrderApiApiOrderGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOrderGet(
      requestParameters: OrderApiApiOrderGetRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<OrderModelODataResultCollection> {
      return localVarFp
        .apiOrderGet(
          requestParameters.isDraft,
          requestParameters.$top,
          requestParameters.$skip,
          requestParameters.$filter,
          requestParameters.$orderby,
          requestParameters.$expand,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Used to provide valid dimensions of Order GridView
     * @param {OrderApiApiOrderGetDocumentFilterDimensionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOrderGetDocumentFilterDimensionsGet(
      requestParameters: OrderApiApiOrderGetDocumentFilterDimensionsGetRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<DocumentFilterDimensions> {
      return localVarFp
        .apiOrderGetDocumentFilterDimensionsGet(
          requestParameters.$filter,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {OrderApiApiOrderGetFileUriListDocEntryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOrderGetFileUriListDocEntryGet(
      requestParameters: OrderApiApiOrderGetFileUriListDocEntryGetRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<FileUriODataResultCollection> {
      return localVarFp
        .apiOrderGetFileUriListDocEntryGet(
          requestParameters.docEntry,
          requestParameters.$top,
          requestParameters.$skip,
          requestParameters.$filter,
          requestParameters.$orderby,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {OrderApiApiOrderGetFormIdDocEntryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOrderGetFormIdDocEntryGet(
      requestParameters: OrderApiApiOrderGetFormIdDocEntryGetRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<number> {
      return localVarFp
        .apiOrderGetFormIdDocEntryGet(
          requestParameters.docEntry,
          requestParameters.isDraft,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary
     * @param {OrderApiApiOrderPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOrderPatch(
      requestParameters: OrderApiApiOrderPatchRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<OrderModel> {
      return localVarFp
        .apiOrderPatch(requestParameters.apiOrderDRAFTPatchRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {OrderApiApiOrderSearchContractDetailsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOrderSearchContractDetailsGet(
      requestParameters: OrderApiApiOrderSearchContractDetailsGetRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<OrderModelODataResultCollection> {
      return localVarFp
        .apiOrderSearchContractDetailsGet(
          requestParameters.searchString,
          requestParameters.$top,
          requestParameters.$skip,
          requestParameters.$filter,
          requestParameters.$orderby,
          requestParameters.$expand,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {OrderApiApiOrderSearchGridViewGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOrderSearchGridViewGet(
      requestParameters: OrderApiApiOrderSearchGridViewGetRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<OrderModelODataResultCollection> {
      return localVarFp
        .apiOrderSearchGridViewGet(
          requestParameters.searchString,
          requestParameters.$top,
          requestParameters.$skip,
          requestParameters.$filter,
          requestParameters.$orderby,
          requestParameters.$expand,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Searches the grid view.
     * @param {OrderApiApiOrderSearchNFilterGridViewPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOrderSearchNFilterGridViewPost(
      requestParameters: OrderApiApiOrderSearchNFilterGridViewPostRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<OrderModelODataResultCollection> {
      return localVarFp
        .apiOrderSearchNFilterGridViewPost(
          requestParameters.$top,
          requestParameters.$skip,
          requestParameters.$filter,
          requestParameters.$orderby,
          requestParameters.$expand,
          requestParameters.apiDeliverySearchNFilterGridViewPostRequest,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary
     * @param {OrderApiApiOrderUpdatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOrderUpdatePost(
      requestParameters: OrderApiApiOrderUpdatePostRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<OrderModel> {
      return localVarFp
        .apiOrderUpdatePost(
          requestParameters.apiOrderDRAFTPatchRequest,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get document by DocEntry and IsDraft
     * @param {OrderApiDocEntryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    docEntryGet(
      requestParameters: OrderApiDocEntryGetRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<OrderModel> {
      return localVarFp
        .docEntryGet(
          requestParameters.docEntry,
          requestParameters.isDraft,
          requestParameters.$expand,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for apiOrderCreateOrdersPost operation in OrderApi.
 * @export
 * @interface OrderApiApiOrderCreateOrdersPostRequest
 */
export interface OrderApiApiOrderCreateOrdersPostRequest {
  /**
   * The OrderCreateModel
   * @type {ApiOrderCreateOrdersPostRequest}
   * @memberof OrderApiApiOrderCreateOrdersPost
   */
  readonly apiOrderCreateOrdersPostRequest?: ApiOrderCreateOrdersPostRequest;
}

/**
 * Request parameters for apiOrderDRAFTDocEntryGet operation in OrderApi.
 * @export
 * @interface OrderApiApiOrderDRAFTDocEntryGetRequest
 */
export interface OrderApiApiOrderDRAFTDocEntryGetRequest {
  /**
   *
   * @type {number}
   * @memberof OrderApiApiOrderDRAFTDocEntryGet
   */
  readonly docEntry: number;

  /**
   *
   * @type {string}
   * @memberof OrderApiApiOrderDRAFTDocEntryGet
   */
  readonly dRAFT: string;

  /**
   *
   * @type {boolean}
   * @memberof OrderApiApiOrderDRAFTDocEntryGet
   */
  readonly isDraft?: boolean;

  /**
   * Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
   * @type {string}
   * @memberof OrderApiApiOrderDRAFTDocEntryGet
   */
  readonly $expand?: string;
}

/**
 * Request parameters for apiOrderDRAFTGet operation in OrderApi.
 * @export
 * @interface OrderApiApiOrderDRAFTGetRequest
 */
export interface OrderApiApiOrderDRAFTGetRequest {
  /**
   *
   * @type {string}
   * @memberof OrderApiApiOrderDRAFTGet
   */
  readonly dRAFT: string;

  /**
   *
   * @type {boolean}
   * @memberof OrderApiApiOrderDRAFTGet
   */
  readonly isDraft?: boolean;

  /**
   * The max number of records. (e.g. $top&#x3D;10)
   * @type {string}
   * @memberof OrderApiApiOrderDRAFTGet
   */
  readonly $top?: string;

  /**
   * The number of records to skip. (e.g. $skip&#x3D;5)
   * @type {string}
   * @memberof OrderApiApiOrderDRAFTGet
   */
  readonly $skip?: string;

  /**
   * A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
   * @type {string}
   * @memberof OrderApiApiOrderDRAFTGet
   */
  readonly $filter?: string;

  /**
   * Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
   * @type {string}
   * @memberof OrderApiApiOrderDRAFTGet
   */
  readonly $orderby?: string;

  /**
   * Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
   * @type {string}
   * @memberof OrderApiApiOrderDRAFTGet
   */
  readonly $expand?: string;
}

/**
 * Request parameters for apiOrderDRAFTGetFormIdDocEntryGet operation in OrderApi.
 * @export
 * @interface OrderApiApiOrderDRAFTGetFormIdDocEntryGetRequest
 */
export interface OrderApiApiOrderDRAFTGetFormIdDocEntryGetRequest {
  /**
   *
   * @type {number}
   * @memberof OrderApiApiOrderDRAFTGetFormIdDocEntryGet
   */
  readonly docEntry: number;

  /**
   *
   * @type {string}
   * @memberof OrderApiApiOrderDRAFTGetFormIdDocEntryGet
   */
  readonly dRAFT: string;

  /**
   *
   * @type {boolean}
   * @memberof OrderApiApiOrderDRAFTGetFormIdDocEntryGet
   */
  readonly isDraft?: boolean;
}

/**
 * Request parameters for apiOrderDRAFTPatch operation in OrderApi.
 * @export
 * @interface OrderApiApiOrderDRAFTPatchRequest
 */
export interface OrderApiApiOrderDRAFTPatchRequest {
  /**
   *
   * @type {string}
   * @memberof OrderApiApiOrderDRAFTPatch
   */
  readonly dRAFT: string;

  /**
   *
   * @type {ApiOrderDRAFTPatchRequest}
   * @memberof OrderApiApiOrderDRAFTPatch
   */
  readonly apiOrderDRAFTPatchRequest?: ApiOrderDRAFTPatchRequest;
}

/**
 * Request parameters for apiOrderDRAFTUpdatePost operation in OrderApi.
 * @export
 * @interface OrderApiApiOrderDRAFTUpdatePostRequest
 */
export interface OrderApiApiOrderDRAFTUpdatePostRequest {
  /**
   *
   * @type {string}
   * @memberof OrderApiApiOrderDRAFTUpdatePost
   */
  readonly dRAFT: string;

  /**
   *
   * @type {ApiOrderDRAFTPatchRequest}
   * @memberof OrderApiApiOrderDRAFTUpdatePost
   */
  readonly apiOrderDRAFTPatchRequest?: ApiOrderDRAFTPatchRequest;
}

/**
 * Request parameters for apiOrderDocEntryGet operation in OrderApi.
 * @export
 * @interface OrderApiApiOrderDocEntryGetRequest
 */
export interface OrderApiApiOrderDocEntryGetRequest {
  /**
   *
   * @type {number}
   * @memberof OrderApiApiOrderDocEntryGet
   */
  readonly docEntry: number;

  /**
   *
   * @type {boolean}
   * @memberof OrderApiApiOrderDocEntryGet
   */
  readonly isDraft?: boolean;

  /**
   * Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
   * @type {string}
   * @memberof OrderApiApiOrderDocEntryGet
   */
  readonly $expand?: string;
}

/**
 * Request parameters for apiOrderGet operation in OrderApi.
 * @export
 * @interface OrderApiApiOrderGetRequest
 */
export interface OrderApiApiOrderGetRequest {
  /**
   *
   * @type {boolean}
   * @memberof OrderApiApiOrderGet
   */
  readonly isDraft?: boolean;

  /**
   * The max number of records. (e.g. $top&#x3D;10)
   * @type {string}
   * @memberof OrderApiApiOrderGet
   */
  readonly $top?: string;

  /**
   * The number of records to skip. (e.g. $skip&#x3D;5)
   * @type {string}
   * @memberof OrderApiApiOrderGet
   */
  readonly $skip?: string;

  /**
   * A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
   * @type {string}
   * @memberof OrderApiApiOrderGet
   */
  readonly $filter?: string;

  /**
   * Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
   * @type {string}
   * @memberof OrderApiApiOrderGet
   */
  readonly $orderby?: string;

  /**
   * Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
   * @type {string}
   * @memberof OrderApiApiOrderGet
   */
  readonly $expand?: string;
}

/**
 * Request parameters for apiOrderGetDocumentFilterDimensionsGet operation in OrderApi.
 * @export
 * @interface OrderApiApiOrderGetDocumentFilterDimensionsGetRequest
 */
export interface OrderApiApiOrderGetDocumentFilterDimensionsGetRequest {
  /**
   * A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
   * @type {string}
   * @memberof OrderApiApiOrderGetDocumentFilterDimensionsGet
   */
  readonly $filter?: string;
}

/**
 * Request parameters for apiOrderGetFileUriListDocEntryGet operation in OrderApi.
 * @export
 * @interface OrderApiApiOrderGetFileUriListDocEntryGetRequest
 */
export interface OrderApiApiOrderGetFileUriListDocEntryGetRequest {
  /**
   *
   * @type {number}
   * @memberof OrderApiApiOrderGetFileUriListDocEntryGet
   */
  readonly docEntry: number;

  /**
   * The max number of records. (e.g. $top&#x3D;10)
   * @type {string}
   * @memberof OrderApiApiOrderGetFileUriListDocEntryGet
   */
  readonly $top?: string;

  /**
   * The number of records to skip. (e.g. $skip&#x3D;5)
   * @type {string}
   * @memberof OrderApiApiOrderGetFileUriListDocEntryGet
   */
  readonly $skip?: string;

  /**
   * A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
   * @type {string}
   * @memberof OrderApiApiOrderGetFileUriListDocEntryGet
   */
  readonly $filter?: string;

  /**
   * Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
   * @type {string}
   * @memberof OrderApiApiOrderGetFileUriListDocEntryGet
   */
  readonly $orderby?: string;
}

/**
 * Request parameters for apiOrderGetFormIdDocEntryGet operation in OrderApi.
 * @export
 * @interface OrderApiApiOrderGetFormIdDocEntryGetRequest
 */
export interface OrderApiApiOrderGetFormIdDocEntryGetRequest {
  /**
   *
   * @type {number}
   * @memberof OrderApiApiOrderGetFormIdDocEntryGet
   */
  readonly docEntry: number;

  /**
   *
   * @type {boolean}
   * @memberof OrderApiApiOrderGetFormIdDocEntryGet
   */
  readonly isDraft?: boolean;
}

/**
 * Request parameters for apiOrderPatch operation in OrderApi.
 * @export
 * @interface OrderApiApiOrderPatchRequest
 */
export interface OrderApiApiOrderPatchRequest {
  /**
   *
   * @type {ApiOrderDRAFTPatchRequest}
   * @memberof OrderApiApiOrderPatch
   */
  readonly apiOrderDRAFTPatchRequest?: ApiOrderDRAFTPatchRequest;
}

/**
 * Request parameters for apiOrderSearchContractDetailsGet operation in OrderApi.
 * @export
 * @interface OrderApiApiOrderSearchContractDetailsGetRequest
 */
export interface OrderApiApiOrderSearchContractDetailsGetRequest {
  /**
   *
   * @type {string}
   * @memberof OrderApiApiOrderSearchContractDetailsGet
   */
  readonly searchString?: string;

  /**
   * The max number of records. (e.g. $top&#x3D;10)
   * @type {string}
   * @memberof OrderApiApiOrderSearchContractDetailsGet
   */
  readonly $top?: string;

  /**
   * The number of records to skip. (e.g. $skip&#x3D;5)
   * @type {string}
   * @memberof OrderApiApiOrderSearchContractDetailsGet
   */
  readonly $skip?: string;

  /**
   * A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
   * @type {string}
   * @memberof OrderApiApiOrderSearchContractDetailsGet
   */
  readonly $filter?: string;

  /**
   * Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
   * @type {string}
   * @memberof OrderApiApiOrderSearchContractDetailsGet
   */
  readonly $orderby?: string;

  /**
   * Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
   * @type {string}
   * @memberof OrderApiApiOrderSearchContractDetailsGet
   */
  readonly $expand?: string;
}

/**
 * Request parameters for apiOrderSearchGridViewGet operation in OrderApi.
 * @export
 * @interface OrderApiApiOrderSearchGridViewGetRequest
 */
export interface OrderApiApiOrderSearchGridViewGetRequest {
  /**
   *
   * @type {string}
   * @memberof OrderApiApiOrderSearchGridViewGet
   */
  readonly searchString?: string;

  /**
   * The max number of records. (e.g. $top&#x3D;10)
   * @type {string}
   * @memberof OrderApiApiOrderSearchGridViewGet
   */
  readonly $top?: string;

  /**
   * The number of records to skip. (e.g. $skip&#x3D;5)
   * @type {string}
   * @memberof OrderApiApiOrderSearchGridViewGet
   */
  readonly $skip?: string;

  /**
   * A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
   * @type {string}
   * @memberof OrderApiApiOrderSearchGridViewGet
   */
  readonly $filter?: string;

  /**
   * Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
   * @type {string}
   * @memberof OrderApiApiOrderSearchGridViewGet
   */
  readonly $orderby?: string;

  /**
   * Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
   * @type {string}
   * @memberof OrderApiApiOrderSearchGridViewGet
   */
  readonly $expand?: string;
}

/**
 * Request parameters for apiOrderSearchNFilterGridViewPost operation in OrderApi.
 * @export
 * @interface OrderApiApiOrderSearchNFilterGridViewPostRequest
 */
export interface OrderApiApiOrderSearchNFilterGridViewPostRequest {
  /**
   * The max number of records. (e.g. $top&#x3D;10)
   * @type {string}
   * @memberof OrderApiApiOrderSearchNFilterGridViewPost
   */
  readonly $top?: string;

  /**
   * The number of records to skip. (e.g. $skip&#x3D;5)
   * @type {string}
   * @memberof OrderApiApiOrderSearchNFilterGridViewPost
   */
  readonly $skip?: string;

  /**
   * A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
   * @type {string}
   * @memberof OrderApiApiOrderSearchNFilterGridViewPost
   */
  readonly $filter?: string;

  /**
   * Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
   * @type {string}
   * @memberof OrderApiApiOrderSearchNFilterGridViewPost
   */
  readonly $orderby?: string;

  /**
   * Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
   * @type {string}
   * @memberof OrderApiApiOrderSearchNFilterGridViewPost
   */
  readonly $expand?: string;

  /**
   * The filter and search string requirement.
   * @type {ApiDeliverySearchNFilterGridViewPostRequest}
   * @memberof OrderApiApiOrderSearchNFilterGridViewPost
   */
  readonly apiDeliverySearchNFilterGridViewPostRequest?: ApiDeliverySearchNFilterGridViewPostRequest;
}

/**
 * Request parameters for apiOrderUpdatePost operation in OrderApi.
 * @export
 * @interface OrderApiApiOrderUpdatePostRequest
 */
export interface OrderApiApiOrderUpdatePostRequest {
  /**
   *
   * @type {ApiOrderDRAFTPatchRequest}
   * @memberof OrderApiApiOrderUpdatePost
   */
  readonly apiOrderDRAFTPatchRequest?: ApiOrderDRAFTPatchRequest;
}

/**
 * Request parameters for docEntryGet operation in OrderApi.
 * @export
 * @interface OrderApiDocEntryGetRequest
 */
export interface OrderApiDocEntryGetRequest {
  /**
   *
   * @type {number}
   * @memberof OrderApiDocEntryGet
   */
  readonly docEntry: number;

  /**
   *
   * @type {boolean}
   * @memberof OrderApiDocEntryGet
   */
  readonly isDraft?: boolean;

  /**
   * Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
   * @type {string}
   * @memberof OrderApiDocEntryGet
   */
  readonly $expand?: string;
}

/**
 * OrderApi - object-oriented interface
 * @export
 * @class OrderApi
 * @extends {BaseAPI}
 */
export class OrderApi extends BaseAPI {
  /**
   *
   * @summary Used to created orders and return release numbers
   * @param {OrderApiApiOrderCreateOrdersPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrderApi
   */
  public apiOrderCreateOrdersPost(
    requestParameters: OrderApiApiOrderCreateOrdersPostRequest = {},
    options?: AxiosRequestConfig
  ) {
    return OrderApiFp(this.configuration)
      .apiOrderCreateOrdersPost(
        requestParameters.apiOrderCreateOrdersPostRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get document by DocEntry and IsDraft
   * @param {OrderApiApiOrderDRAFTDocEntryGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrderApi
   */
  public apiOrderDRAFTDocEntryGet(
    requestParameters: OrderApiApiOrderDRAFTDocEntryGetRequest,
    options?: AxiosRequestConfig
  ) {
    return OrderApiFp(this.configuration)
      .apiOrderDRAFTDocEntryGet(
        requestParameters.docEntry,
        requestParameters.dRAFT,
        requestParameters.isDraft,
        requestParameters.$expand,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Default action to acquire list of documents by IsDraft
   * @param {OrderApiApiOrderDRAFTGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrderApi
   */
  public apiOrderDRAFTGet(
    requestParameters: OrderApiApiOrderDRAFTGetRequest,
    options?: AxiosRequestConfig
  ) {
    return OrderApiFp(this.configuration)
      .apiOrderDRAFTGet(
        requestParameters.dRAFT,
        requestParameters.isDraft,
        requestParameters.$top,
        requestParameters.$skip,
        requestParameters.$filter,
        requestParameters.$orderby,
        requestParameters.$expand,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {OrderApiApiOrderDRAFTGetFormIdDocEntryGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrderApi
   */
  public apiOrderDRAFTGetFormIdDocEntryGet(
    requestParameters: OrderApiApiOrderDRAFTGetFormIdDocEntryGetRequest,
    options?: AxiosRequestConfig
  ) {
    return OrderApiFp(this.configuration)
      .apiOrderDRAFTGetFormIdDocEntryGet(
        requestParameters.docEntry,
        requestParameters.dRAFT,
        requestParameters.isDraft,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary
   * @param {OrderApiApiOrderDRAFTPatchRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrderApi
   */
  public apiOrderDRAFTPatch(
    requestParameters: OrderApiApiOrderDRAFTPatchRequest,
    options?: AxiosRequestConfig
  ) {
    return OrderApiFp(this.configuration)
      .apiOrderDRAFTPatch(
        requestParameters.dRAFT,
        requestParameters.apiOrderDRAFTPatchRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary
   * @param {OrderApiApiOrderDRAFTUpdatePostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrderApi
   */
  public apiOrderDRAFTUpdatePost(
    requestParameters: OrderApiApiOrderDRAFTUpdatePostRequest,
    options?: AxiosRequestConfig
  ) {
    return OrderApiFp(this.configuration)
      .apiOrderDRAFTUpdatePost(
        requestParameters.dRAFT,
        requestParameters.apiOrderDRAFTPatchRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get document by DocEntry and IsDraft
   * @param {OrderApiApiOrderDocEntryGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrderApi
   */
  public apiOrderDocEntryGet(
    requestParameters: OrderApiApiOrderDocEntryGetRequest,
    options?: AxiosRequestConfig
  ) {
    return OrderApiFp(this.configuration)
      .apiOrderDocEntryGet(
        requestParameters.docEntry,
        requestParameters.isDraft,
        requestParameters.$expand,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Default action to acquire list of documents by IsDraft
   * @param {OrderApiApiOrderGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrderApi
   */
  public apiOrderGet(
    requestParameters: OrderApiApiOrderGetRequest = {},
    options?: AxiosRequestConfig
  ) {
    return OrderApiFp(this.configuration)
      .apiOrderGet(
        requestParameters.isDraft,
        requestParameters.$top,
        requestParameters.$skip,
        requestParameters.$filter,
        requestParameters.$orderby,
        requestParameters.$expand,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Used to provide valid dimensions of Order GridView
   * @param {OrderApiApiOrderGetDocumentFilterDimensionsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrderApi
   */
  public apiOrderGetDocumentFilterDimensionsGet(
    requestParameters: OrderApiApiOrderGetDocumentFilterDimensionsGetRequest = {},
    options?: AxiosRequestConfig
  ) {
    return OrderApiFp(this.configuration)
      .apiOrderGetDocumentFilterDimensionsGet(
        requestParameters.$filter,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {OrderApiApiOrderGetFileUriListDocEntryGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrderApi
   */
  public apiOrderGetFileUriListDocEntryGet(
    requestParameters: OrderApiApiOrderGetFileUriListDocEntryGetRequest,
    options?: AxiosRequestConfig
  ) {
    return OrderApiFp(this.configuration)
      .apiOrderGetFileUriListDocEntryGet(
        requestParameters.docEntry,
        requestParameters.$top,
        requestParameters.$skip,
        requestParameters.$filter,
        requestParameters.$orderby,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {OrderApiApiOrderGetFormIdDocEntryGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrderApi
   */
  public apiOrderGetFormIdDocEntryGet(
    requestParameters: OrderApiApiOrderGetFormIdDocEntryGetRequest,
    options?: AxiosRequestConfig
  ) {
    return OrderApiFp(this.configuration)
      .apiOrderGetFormIdDocEntryGet(
        requestParameters.docEntry,
        requestParameters.isDraft,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary
   * @param {OrderApiApiOrderPatchRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrderApi
   */
  public apiOrderPatch(
    requestParameters: OrderApiApiOrderPatchRequest = {},
    options?: AxiosRequestConfig
  ) {
    return OrderApiFp(this.configuration)
      .apiOrderPatch(requestParameters.apiOrderDRAFTPatchRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {OrderApiApiOrderSearchContractDetailsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrderApi
   */
  public apiOrderSearchContractDetailsGet(
    requestParameters: OrderApiApiOrderSearchContractDetailsGetRequest = {},
    options?: AxiosRequestConfig
  ) {
    return OrderApiFp(this.configuration)
      .apiOrderSearchContractDetailsGet(
        requestParameters.searchString,
        requestParameters.$top,
        requestParameters.$skip,
        requestParameters.$filter,
        requestParameters.$orderby,
        requestParameters.$expand,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {OrderApiApiOrderSearchGridViewGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrderApi
   */
  public apiOrderSearchGridViewGet(
    requestParameters: OrderApiApiOrderSearchGridViewGetRequest = {},
    options?: AxiosRequestConfig
  ) {
    return OrderApiFp(this.configuration)
      .apiOrderSearchGridViewGet(
        requestParameters.searchString,
        requestParameters.$top,
        requestParameters.$skip,
        requestParameters.$filter,
        requestParameters.$orderby,
        requestParameters.$expand,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Searches the grid view.
   * @param {OrderApiApiOrderSearchNFilterGridViewPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrderApi
   */
  public apiOrderSearchNFilterGridViewPost(
    requestParameters: OrderApiApiOrderSearchNFilterGridViewPostRequest = {},
    options?: AxiosRequestConfig
  ) {
    return OrderApiFp(this.configuration)
      .apiOrderSearchNFilterGridViewPost(
        requestParameters.$top,
        requestParameters.$skip,
        requestParameters.$filter,
        requestParameters.$orderby,
        requestParameters.$expand,
        requestParameters.apiDeliverySearchNFilterGridViewPostRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary
   * @param {OrderApiApiOrderUpdatePostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrderApi
   */
  public apiOrderUpdatePost(
    requestParameters: OrderApiApiOrderUpdatePostRequest = {},
    options?: AxiosRequestConfig
  ) {
    return OrderApiFp(this.configuration)
      .apiOrderUpdatePost(requestParameters.apiOrderDRAFTPatchRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get document by DocEntry and IsDraft
   * @param {OrderApiDocEntryGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrderApi
   */
  public docEntryGet(
    requestParameters: OrderApiDocEntryGetRequest,
    options?: AxiosRequestConfig
  ) {
    return OrderApiFp(this.configuration)
      .docEntryGet(
        requestParameters.docEntry,
        requestParameters.isDraft,
        requestParameters.$expand,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}
